import {
    loanPurposeDefault,
    loanPurposeDefaultAEM,
    LoanPurposeState,
} from './loanPurposeTypes';
import { ApiStatus } from '../../types';
export const initialStateLoanPurpose: LoanPurposeState = {
    content: loanPurposeDefaultAEM,
    loanPurposeData: loanPurposeDefault,
    selectedLoanPurposeIds: [],
    updateLoanPurposeRequest: { 
        applicationNumber: '123456',
        selectedLoanPurposeIds: [],
    },
    getLoanPurposeApiStatus: ApiStatus.Idle,
    updateLoanPurposeApiStatus: ApiStatus.Idle,
    apiEndpoints: {
        getLoanPurposeApiUrl: '/getLoanPurposes',
        updateLoanPurposeApiUrl: '/saveLoanPurposes',
    },
};
